
import {Options, Vue} from "vue-class-component";
import {Client} from "@/types/client";
import ModuleClients from "@/store/clients";

@Options({
})
export default class Clients extends Vue {
    private search: string = '';
    private headers = [
        { title: 'Name', value: 'name' },
        { title: 'Objectives', value: 'objectives' },
        { title: 'Progress', value: 'progress' },
        { title: 'Active', value: 'active' }
    ];

    get allClients(): Client[] {
        return ModuleClients.allClients || [];
    }

    async mounted() {
        await ModuleClients.getAllClients();
    }
}
